<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- Bookmarks Container -->
      <bookmarks v-if="$can('manage', 'all')" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <search-bar />
      <!-- <locale /> -->
      <!-- <dark-toggler class="d-none d-lg-block" /> -->
      <!-- <notification-dropdown /> -->
      <b-badge v-if="isDev" class="p-50 mx-50" variant="info">
        {{ currentBreakPoint }}
      </b-badge>
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BBadge } from "bootstrap-vue";
import Bookmarks from "./components/Bookmarks.vue";
// import Locale from "./components/Locale.vue";
import SearchBar from "./components/SearchBar.vue";
// import DarkToggler from './components/DarkToggler.vue'
// import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from "./components/UserDropdown.vue";

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    // Locale,
    SearchBar,
    // DarkToggler,
    // NotificationDropdown,
    UserDropdown,
    BBadge,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    currentBreakPoint() {
      return this.$store.getters["app/currentBreakPoint"];
    },
    isDev() {
      return this.$store.getters["app/isDev"];
    },
  },
};
</script>
